module.exports = __webpack_public_path__ + "img/Eat-Us-Alive-cover.96888e23.png";